import React from 'react'
import { useState } from "react";
import { UserRound } from 'lucide-react';
import { Heart } from 'lucide-react';
import { ShoppingBag } from 'lucide-react';
import { History } from 'lucide-react';
import { MapPinHouse } from 'lucide-react';
import toast from "react-hot-toast";
import { UserRoundPen } from 'lucide-react';
import { persistor } from "../redux/store/store";
import { useDispatch } from "react-redux";
import { Car } from 'lucide-react';
import { logout } from "../redux/reduxSlice/SingIn&Singup/SingInSlice";
import { LogOut } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { LiaOpencart } from "react-icons/lia";
export default function AccountNav() {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const [authToken, setAuthToken] = useState(null);
    // const handleLogout = () => {
    //     localStorage.removeItem("authToken"); // Remove token from localStorage
    //     localStorage.removeItem("UserRowId");
    //     localStorage.removeItem("redirect");
    //     localStorage.removeItem("user");
    //     // localStorage.removeItem("persist:root");
    //     dispatch(logout());
    //     persistor.purge();

    //     setAuthToken(null); // Clear token from localStorage
    //     toast.success("Logged out successfully");
    //     navigate("/login"); // Redirect to login page
    //     window.location.reload();
    // };
    const handleLogout = async () => {
  try {
    // remove auth
    localStorage.removeItem("authToken");
    localStorage.removeItem("UserRowId");
    localStorage.removeItem("redirect");
    localStorage.removeItem("user");
    localStorage.removeItem("loggedCustomer");

    // clear redux state
    dispatch(logout());

    // WAIT for persist clear
    await persistor.purge();
    await persistor.flush();

    toast.success("Logged out successfully");

    navigate("/login", { replace: true });

  } catch (e) {
    console.error(e);
  }
};

    return (
        <div>
            <div style={{ height: '100vh' }} className=" hidden w-[275px] flex-col bg-[#b1c9a4] lg:block">
                <ul className=" flex flex-col item-start w-full p-2 " style={{ height: '90vh' }}>
                    <li className='m-1 hover:text-white'>
                        <Link to="/account/dashboard" >
                            <div className="bg-[#66944b] hover:border border-1 border-[#dff7eb] hover:bg-[#588040]  hover:text-[#dff7eb] text-white p-2  rounded flex items-center">
                                <UserRound />
                                <span className="text-md font-semibold ml-2">Dashboard</span>
                            </div>
                        </Link>
                    </li>
                    <li className='m-1 hover:text-white'>
                        <Link to="/account/wishlist" >
                            <div className="bg-[#66944b] hover:border border-1 border-[#dff7eb] hover:bg-[#588040]  hover:text-[#dff7eb] text-white p-2 rounded flex items-center">
                                <Heart />
                                <span className="text-md font-semibold ml-2">Wishlist</span>
                            </div>
                        </Link>
                    </li>
                    <li className='m-1 hover:text-white'>
                        <Link to="/addtocart" >
                            <div className="bg-[#66944b] hover:border border-1 border-[#dff7eb] hover:bg-[#588040]  hover:text-[#dff7eb] text-white p-2 rounded flex items-center">
                                <LiaOpencart className='text-2xl text-bold' />
                                <span className="text-md font-semibold ml-2">Cart</span>
                            </div>
                        </Link>
                    </li>
                    <li className='m-1 hover:text-white'>
                        <Link to="/account/orders" >
                            <div className="bg-[#66944b] hover:border border-1 border-[#dff7eb] hover:bg-[#588040]  hover:text-[#dff7eb] text-white p-2 rounded flex items-center">
                                <ShoppingBag />
                                <span className="text-md font-semibold ml-2">Orders</span>
                            </div>
                        </Link>
                    </li>
                    <li className="m-1 hover:text-white">
                        <Link to="/account/edit-address" >
                            <div className="bg-[#66944b] hover:border border-1 border-[#dff7eb] hover:bg-[#588040]  hover:text-[#dff7eb] text-white p-2 rounded flex items-center">
                                <MapPinHouse />
                                <span className="text-lg font-semibold ml-2">Addresses</span>
                            </div>
                        </Link>
                    </li>
                    <li className="m-1 hover:text-white">
                        <Link to="/account/edit-account" >
                            <div className="bg-[#66944b] hover:border border-1 border-[#dff7eb] hover:bg-[#588040] hover:text-[#dff7eb] text-white p-2 rounded flex items-center">
                                <UserRoundPen />
                                <span className="text-lg font-semibold ml-2">Account details</span>
                            </div>
                        </Link>
                    </li>
                    <li className="m-1 hover:text-white">
                        <Link
                            onClick={() => {
                                handleLogout();
                            }}
                        >
                            <div className="bg-[#66944b] hover:border border-1 border-[#dff7eb] hover:bg-[#588040]  hover:text-[#dff7eb] text-white p-2 rounded flex items-center">
                                <LogOut />
                                <span className="text-md font-semibold ml-2">Log out </span>
                            </div>
                        </Link>
                    </li>
                </ul>

            </div>
        </div>
    )
}